var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dropdown-text",on:{"click":_vm.redirect}},[_c('span',[_vm._v(_vm._s(_vm.resource.name))]),_c('br'),_vm._v(" "),_c('small',[_vm._v(_vm._s(_vm.resource.trajectory_type ? _vm.resource.trajectory_type.value : '-'))])])
}
var staticRenderFns = []

export { render, staticRenderFns }